(function () {
  var STAGE_SELECTOR = '.progress-bar-stage';
  var TARGET_COUNT = 3;

  // Match by product handle first (stable even if titles change), then by
  // title fragment as a fallback for products without a handle in the payload.
  var EXCLUDED_HANDLES = [
    'deep-fitted-sheet',
    'deep-fitted-sheet-upgrade-18inches',
    'gift-100-cotton-embroidered-towel-73x33cm',
    'shipping-insurance',
    'shipping-protection'
  ];
  var EXCLUDED_TITLE_FRAGMENTS = [
    'deep fitted sheet',
    'deep pocket',
    'shipping protection',
    'shipping insurance',
    'towel'
  ];

  function isExcluded(item) {
    var handle = (item.handle || '').toLowerCase();
    if (EXCLUDED_HANDLES.indexOf(handle) !== -1) return true;

    var title = (item.product_title || '').toLowerCase();
    for (var i = 0; i < EXCLUDED_TITLE_FRAGMENTS.length; i++) {
      if (title.indexOf(EXCLUDED_TITLE_FRAGMENTS[i]) !== -1) return true;
    }
    return false;
  }

  function updateBar(cart) {
    var stages = document.querySelectorAll(STAGE_SELECTOR);
    if (!stages.length || !cart || !cart.items) return;

    var eligibleCount = 0;
    cart.items.forEach(function (item) {
      if (!isExcluded(item)) {
        eligibleCount += item.quantity;
      }
    });

    var progressPercentage = Math.min(100, Math.max(0, (eligibleCount / TARGET_COUNT) * 100));

    stages.forEach(function (stage, index) {
      var stageCompletion = Math.max(0, progressPercentage - index * 33.33);
      stage.style.width = Math.min(33.33, stageCompletion) + '%';
    });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(updateBar)
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);

  // Fired by theme.js after quantity changes — reuse the cart payload if present
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateBar(evt.detail.cart);
    } else {
      refresh();
    }
  });

  // Fired when a product is added from a product page / quick shop
  document.addEventListener('ajaxProduct:added', refresh);

  // Fired when any drawer opens — cheap safety net so the bar is always current
  document.addEventListener('drawerOpen', refresh);
})();
